export default "__VITE_ASSET__BBvD5xsv__"